<template>
    <Layout v-if="state.isLayout">
        <Drawer
            v-if="state.isMobile"
            placement="left"
            :closable="false"
            :visible="!state.collapsed"
            @close="() => onCollapsed(!state.collapsed)"
            :drawerStyle="{ background: 'var(--layout-sider-custom-background)' }"
            :bodyStyle="{ padding: '0px' }"
        >
            <AppMenu></AppMenu>
        </Drawer>
        <Sider
            :collapsed="state.collapsed"
            :trigger="null"
            collapsible
            breakpoint="md"
            @breakpoint="onBreakpoint"
            :collapsedWidth="state.isMobile ? 0 : state.sidebar.collapsedWidth"
            :width="state.isMobile ? 0 : state.sidebar.width"
            class="sidebar"
            :style="{ background: 'var(--layout-sider-custom-background)' }"
            :ref="e => (refs.sider = e)"
        >
            <AppMenu></AppMenu>
        </Sider>
        <Layout class="container" :style="containerStyle">
            <Header :ref="e => (refs.header = e)" class="header px-0">
                <div :style="containerStyle">
                    <div class="px-3">
                        <div class="d-flex align-items-center">
                            <ToggleButton></ToggleButton>
                            <div class="ml-auto">
                                <Notification></Notification>
                                <!-- <Lang class="ml-3"></Lang> -->
                                <Account class="ml-3"></Account>
                            </div>
                        </div>
                    </div>
                    <AppPageHeader></AppPageHeader>
                </div>
            </Header>
            <Content class="content" :style="contentStyle">
                <router-view :key="`${$route.path}${state._timestamp}`"></router-view>
            </Content>
            <Footer class="footer">
                <AppFooter></AppFooter>
            </Footer>
        </Layout>
    </Layout>
    <div v-else>
        <AppPageHeader class="pt-4"></AppPageHeader>
        <router-view :key="`${$route.path}${state._timestamp}`"></router-view>
    </div>
</template>

<script>
import { Drawer, Layout } from "ant-design-vue";
import lodash from "lodash";
import { defineAsyncComponent, defineComponent, onMounted, onUnmounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import websocket from "../../../utils/websocket";
import {
    containerStyle,
    contentStyle,
    mapDataItemToMenu,
    onBreakpoint,
    onCollapsed,
    onWebsocketConnect,
    refreshSidebar,
    refs,
    state
} from "./app-layout.logic";

export default defineComponent({
    components: {
        Layout,
        Sider: Layout.Sider,
        Header: Layout.Header,
        Content: Layout.Content,
        Footer: Layout.Footer,
        Drawer,
        AppMenu: defineAsyncComponent(() => import("./AppMenu")),
        ToggleButton: defineAsyncComponent(() => import("./ToggleButton")),
        Notification: defineAsyncComponent(() => import("./Notification")),
        //Lang: defineAsyncComponent(() => import("./Lang")),
        Account: defineAsyncComponent(() => import("./Account")),
        AppPageHeader: defineAsyncComponent(() => import("./AppPageHeader")),
        AppFooter: defineAsyncComponent(() => import("./AppFooter"))
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        if (window.menuSides) {
            state.menuSides = lodash.cloneDeep(window.menuSides);
            refreshSidebar();
        } else {
            store.dispatch("resource/v1/security/menuSide/getDataItem").then(menuSides => {
                state.menuSides = mapDataItemToMenu(menuSides);
                refreshSidebar();
            });
            state.websocketId = websocket.connect(onWebsocketConnect);
            onUnmounted(() => state.websocketSubscribes.forEach(d => websocket.unsubscribe(d.path, d.id)));
        }
        onMounted(() =>
            setInterval(() => {
                contentStyle.marginTop = `${refs.header?.$el?.offsetHeight || 0}px`;
                if (state.isMobile) {
                    containerStyle.marginLeft = "0px";
                } else if (state.collapsed) {
                    containerStyle.marginLeft = state.sidebar.collapsedWidth;
                } else {
                    containerStyle.marginLeft = `${refs.sider?.$el?.offsetWidth || 0}px`;
                }
            }, 250)
        );
        watch(
            () => route.query,
            () => {
                if (route.query._timestamp) state._timestamp = route.query._timestamp;
            }
        );
        state.isLayout = route.query.isLayout !== "false";
        return { refs, state, onBreakpoint, onCollapsed, containerStyle, contentStyle };
    }
});
</script>

<style>
.sidebar {
    overflow: auto;
    height: 100vh;
    position: fixed;
    left: 0;
    z-index: 150;
    max-width: 100% !important;
}

.sidebar::-webkit-scrollbar {
    width: 10px;
}

.sidebar:hover::-webkit-scrollbar-thumb {
    background: #888;
}

.sidebar::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.header {
    position: fixed;
    z-index: 100;
    width: 100%;
    left: 0px;
    height: auto;
    color: var(--layout-header-color);
    background: var(--layout-header-background) !important;
}

.content {
    transition: 0.25s;
}
</style>
